import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
} from '@mui/material';
import {
  FlightTakeoff as VuelosIcon,
  Route as RutasIcon,
  Airlines as AerolineaIcon,
  LocationCity as EstacionesIcon,
  BookmarkBorder as BookingsIcon,
  LocalShipping as LoadingIcon,
} from '@mui/icons-material';

const AerolineaIndex = () => {
  const modules = [
    {
      title: 'Gestión de Vuelos',
      description: 'Crear vuelos, asignar equipo y cliente',
      link: '/aerolinea/vuelos',
      icon: VuelosIcon,
      gradient: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
    },
    {
      title: 'Rutas / Instancias',
      description: 'Configurar rutas, escalas y capacidades',
      link: '/aerolinea/rutas',
      icon: RutasIcon,
      gradient: 'linear-gradient(135deg, #E65100 0%, #BF360C 100%)',
    },
    {
      title: 'Loading List',
      description: 'Asignar carga a vuelos desde el inventario',
      link: '/aerolinea/loading',
      icon: LoadingIcon,
      gradient: 'linear-gradient(135deg, #7B1FA2 0%, #9C27B0 100%)',
    },
    {
      title: 'Reservas de Carga',
      description: 'Gestión de capacidad y reservas por vuelo',
      link: '/aerolinea/bookings',
      icon: BookingsIcon,
      gradient: 'linear-gradient(135deg, #00695C 0%, #00897B 100%)',
    },
    {
      title: 'Estaciones',
      description: 'Gestión de aeropuertos y códigos IATA',
      link: '/aerolinea/estaciones',
      icon: EstacionesIcon,
      gradient: 'linear-gradient(135deg, #5E35B1 0%, #7C4DFF 100%)',
    },
  ];

  return (
    <Box>
      {/* Header */}
      <Card
        sx={{
          mb: 4,
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          color: 'white',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AerolineaIcon sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Aerolínea
              </Typography>
              <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                Panel de administración de vuelos y reservas
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Modules Grid */}
      <Grid container spacing={3}>
        {modules.map((module) => {
          const IconComponent = module.icon;
          return (
            <Grid item xs={12} sm={6} lg={3} key={module.title}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardActionArea
                  component={Link}
                  to={module.link}
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                >
                  <Box
                    sx={{
                      background: module.gradient,
                      p: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <IconComponent sx={{ fontSize: 48, color: 'white' }} />
                  </Box>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {module.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {module.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default AerolineaIndex;

